import { SalesHistoryProduct } from "./sales-history-product";

export class SalesHistoryCompanySummary {
  private fiscalNumber: string;
  private corporateName: string;
  private productSoldCount: number;
  private salesHistoryProductList: SalesHistoryProduct[];

  setFiscalNumber(value: string): void {
    this.fiscalNumber = value;
  }

  getFiscalNumber(): string {
    return this.fiscalNumber;
  }

  setCorporateName(value: string): void {
    this.corporateName = value;
  }

  getCorporateName(): string {
    return this.corporateName;
  }

  setProductSoldCount(value: number): void {
    this.productSoldCount = value;
  }

  getProductSoldCount(): number {
    return this.productSoldCount;
  }

  setSalesHistoryProductList(value: SalesHistoryProduct[]): void {
    this.salesHistoryProductList = value;
  }

  getSalesHistoryProductList(): SalesHistoryProduct[] {
    return this.salesHistoryProductList;
  }
}
